/**
 * Handle beforeunload event
 *
 * Subject to Safari's "Runaway JavaScript Timer" and
 * Chrome V8 extension that terminates JS that exhibits
 * "slow unload", i.e., calling getTime() > 1000 times
 * @param {{
 *  asyncTrackers: Array<{trackHeartBeat:function({lastHeartbeat: boolean}): void}>,
 *  syncTrackers: Array<{trackHeartBeat:function({lastHeartbeat: boolean}): void}>
 * }} trackers
 * @param {number} [expireDateTime]
 * @returns {void}
 */
export function beforeUnloadHandler(trackers, expireDateTime) {
  for (let i = 0; i < trackers.asyncTrackers.length; i += 1) {
    trackers.asyncTrackers[i].trackHeartBeat({ lastHeartbeat: true });
  }

  for (let i = 0; i < trackers.syncTrackers.length; i += 1) {
    trackers.syncTrackers[i].trackHeartBeat({ lastHeartbeat: true });
  }

  /*
   * Delay/pause (blocks UI)
   */
  if (expireDateTime) {
    // TODO: PPI-1422 - it can be refactored/improved according the comment below
    // the things we do for backwards compatibility...
    // in ECMA-262 5th ed., we could simply use:
    //     while (Date.now() < expireDateTime) { }

    /**
     * @type {Date}
     */
    let now;
    do {
      now = new Date();
    } while (now.getTime() < expireDateTime);
  }
}
